var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8553 9.20059L14.1053 3.57556C14.0594 3.23565 13.883 2.92306 13.609 2.69632C13.335 2.46958 12.9823 2.34423 12.6168 2.34375H1.99963C1.73451 2.34403 1.48033 2.4429 1.29286 2.61865C1.10539 2.79441 0.999937 3.0327 0.999634 3.28125V8.4375C0.999937 8.68605 1.10539 8.92434 1.29286 9.1001C1.48033 9.27585 1.73451 9.37472 1.99963 9.375H4.69061L7.05243 13.8034C7.09395 13.8812 7.15778 13.9467 7.23676 13.9925C7.31575 14.0383 7.40678 14.0625 7.49963 14.0625C8.16244 14.0618 8.79789 13.8146 9.26657 13.3753C9.73525 12.9359 9.99888 12.3401 9.99963 11.7188V10.7812H13.3668C13.5795 10.7813 13.7898 10.7388 13.9836 10.6569C14.1775 10.5749 14.3506 10.4552 14.4914 10.3057C14.6321 10.1562 14.7374 9.98035 14.8001 9.78983C14.8628 9.59931 14.8817 9.39845 14.8553 9.20059V9.20059ZM4.49963 8.4375H1.99963V3.28125H4.49963V8.4375Z",
    fill: "#FF6978"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.adc39462af89820295c20bebc8f079e7.svg";
export { ForwardRef as ReactComponent };